import axios from "axios";
import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../components/Login.vue';
import VerifyMFA from '../components/VerifyMFA.vue';
import Layout from '../components/Layout.vue';
import Home from '../components/Home.vue';
import Admin from '../components/Admin.vue';
import Measurement from '../components/Measurement.vue';
import ForgotPassword from '../components/ForgotPassword.vue';
import HealthProgressChart from "../components/Dashboard/HealthProgress_ProgressChart.vue"
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    meta: {
      authRequired: true
    },
    children: [
      {
        path: '',
        name: '',
        component: Home  ,
      },
      {
        path: 'measurement/:id',
        name: 'measurement',
        component: Measurement,
      },
      {
        path: 'admin',
        name: 'admin',
        component: Admin,
      },
    ]
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: ForgotPassword,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path:'/verify-mfa/:id',
    name:'verify-mfa',
    component:VerifyMFA
  },
  { path: '*', redirect: '/' }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  let token = '';
  let user = '';
  try {
    user = JSON.parse(localStorage.getItem('user'));
    const urlParams = new URLSearchParams(window.location.search);
    token = urlParams.get('token') || (user && user.token);
    if (token) {
      axios.defaults.headers.common['token'] = token;
    }
  } catch (e) {
    console.log("error oc", e);
  }
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['login', 'forgotpassword','verify-mfa'];
  const authRequired = !publicPages.includes(to.name);
  console.log(to,authRequired)
  const loggedIn = token || user;
  if (authRequired && !loggedIn) {
    return next(`/login?returnUrl=${window.location.pathname}`);
  } else if (authRequired && user && !user.passwordChanged) {
    return next(`/forgotpassword?token=${token}`);
  } else {
    return next();
  }
});


export default router;
